import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dumbbell } from 'lucide-react';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Sign In | Active Onyx Fit';
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }
    login({ email: formData.email, firstName: 'Customer', lastName: '' });
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-[140px] pb-20">
        <div className="max-w-md mx-auto px-6">
          <div className="text-center mb-10">
            <div className="w-16 h-16 bg-gradient-to-br from-titan-600 to-titan-500 rounded-xl flex items-center justify-center mx-auto mb-6">
              <Dumbbell className="w-8 h-8 text-slate-900" />
            </div>
            <h1 className="font-display text-3xl text-slate-900 uppercase tracking-tight mb-2">Welcome Back</h1>
            <p className="text-neutral-400">Sign in to your account</p>
          </div>
          
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="p-3 bg-red-500/10 border border-red-500/30 text-red-500 text-sm rounded-xl">
                  {error}
                </div>
              )}
              
              <div>
                <Label className="text-sm font-semibold text-slate-900">Email</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="mt-2 bg-neutral-800 border-neutral-700 text-slate-900 placeholder-neutral-500 focus:ring-titan-500 focus:border-titan-500 rounded-xl"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <Label className="text-sm font-semibold text-slate-900">Password</Label>
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="mt-2 bg-neutral-800 border-neutral-700 text-slate-900 placeholder-neutral-500 focus:ring-titan-500 focus:border-titan-500 rounded-xl"
                  placeholder="••••••••"
                />
              </div>
              
              <div className="flex items-center justify-end">
                <Link to="/forgot-password" className="text-sm text-titan-500 hover:text-titan-400">
                  Forgot password?
                </Link>
              </div>
              
              <button 
                type="submit" 
                className="w-full py-4 bg-gradient-to-r from-titan-600 to-titan-500 hover:from-titan-500 hover:to-titan-400 text-slate-900 font-bold uppercase tracking-wider rounded-xl transition-all shadow-button"
              >
                Sign In
              </button>
            </form>
          </div>
          
          <p className="text-center mt-6 text-neutral-400 text-sm">
            Don't have an account?{' '}
            <Link to="/register" className="text-titan-500 font-medium hover:text-titan-400">
              Create account
            </Link>
          </p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LoginPage;
